export default __webpack_public_path__ + "static/media/Blade's Armbands of the Hidden Tomb.2687fe4e.jpg";